import "./About.css"

export default function About() {
    return (
        <main className="About">
            <h1 className="big-text">
                I am passionate about turning complex problems into simple solutions ...
            </h1>
            <p className="small-text">
                Hi! I'm Selina and I am a second year studying Computer Science and Statistics at the University of British Columbia (UBC).
                My areas of interest within tech include statistical analysis and program design. However, I am also a curious person by nature and love to learn new things!
                I am currently looking for Summmer or September 2026 internships.
                <br></br>
                <br></br>
                Outside of school, I enjoy eating good food, hanging out with friends/family and photography.
                You can check out some snippets of my life and photography below!
            </p>

            



        </main>
    )

}